import { Chip } from "@mui/material";

/**
 * Reusable pill-shaped action button with icon + label.
 * Use for inline actions like "Compose", "Invite", "Tag", etc.
 *
 * Props:
 *  - label: string displayed inside the pill
 *  - icon: React element (MUI icon)
 *  - color: text/icon color (default "#7C3AED")
 *  - bgColor: background color (default "#EDE9FE")
 *  - borderColor: border color (default "#C4B5FD")
 *  - hoverBgColor: hover background (default darker shade of bgColor)
 *  - onClick: click handler
 *  - sx: additional sx overrides
 */
const PillActionButton = ({
  label,
  icon,
  color = "#7C3AED",
  bgColor = "#EDE9FE",
  borderColor = "#C4B5FD",
  hoverBgColor = "#DDD6FE",
  onClick,
  sx: sxProp,
  ...props
}) => (
  <Chip
    icon={icon}
    label={label}
    size="small"
    clickable
    onClick={onClick}
    sx={{
      height: 22,
      fontSize: 11,
      fontWeight: 600,
      backgroundColor: bgColor,
      color,
      border: `1px solid ${borderColor}`,
      "& .MuiChip-icon": { color, ml: 0.5, fontSize: 14 },
      "&:hover": { backgroundColor: hoverBgColor },
      ...sxProp,
    }}
    {...props}
  />
);

export default PillActionButton;
